import {
  GET_REGISTRATION_REQUESTED,
  GET_REGISTRATION_SUCCESS,
  GET_REGISTRATION_FAILED,
} from 'resources/actionTypes';

const initialState = {
  userRegistration: [],
  loading: false,
  error: null,
};

export default function userRegistration(state = initialState, action) {
  switch (action.type) {
    case GET_REGISTRATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        userRegistration: action.userRegistration,
      };
    case GET_REGISTRATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
